import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import {
  ViConfirmDialog,
  ViConfirmDialogComponent,
} from './confirm-dialog/confirm-dialog.component';

@Injectable()
export class ViConfirmDialogService {
  confirmDialogRef: MatDialogRef<ViConfirmDialogComponent>;

  constructor(private matDialog: MatDialog) {}

  open(data: ViConfirmDialog): Observable<boolean> {
    this.confirmDialogRef = this.matDialog.open(ViConfirmDialogComponent, {
      width: '480px',
      panelClass: 'confirm-dialog',
      disableClose: true,
      data,
    });

    return this.confirmDialogRef.afterClosed();
  }

  close(): void {
    return this.confirmDialogRef.close();
  }
}
